module.exports = __webpack_public_path__ + "img/wedding-08.60a9cec4.jpg";